import { apiAxios } from '../../../../helpers/api'

export const getList = async (commit, url, type) => {
  commit('updateLoading', true)
  const result = await apiAxios
    .post(url)
    .finally(_ => commit('updateLoading', false))
  commit('updateList', result.data.data[type])
}
export const getSelectList = async ({ commit }, payload) => {
  const set = payload.set !== false
  delete payload.set

  commit('updateLoading', true)
  const result = await apiAxios
    .post('tournaments/select')
    .finally(_ => commit('updateLoading', false))
  if (set) commit('updateSelectList', result.data.data.tournaments || [])
  return result.data.data.tournaments || []
}
export const getOne = async (commit, id, url, type) => {
  commit('updateLoading', true)
  const result = await apiAxios
    .get(url + id)
    .finally(_ => commit('updateLoading', false))
  commit('updateOne', result.data.data[type])
  return result.data.data[type]
}
export const refreshOne = async ({ commit, dispatch }, id, url, type) => {
  try {
    commit('updateLoading', true)
    const result = await apiAxios.get(url + id)
    await Promise.all([
      dispatch('matches/query', { tournamentId: id }, { root: true }),
      dispatch('matches/setRanking', { tournamentId: id }, { root: true }),
      dispatch('matches/setResults', id, { root: true }),
      dispatch('advertising/setInit', { tournamentId: id }, { root: true }),
      dispatch('courses/setInit', { tournaments: id }, { root: true })
    ])
    commit('updateOne', result.data.data[type])
    return result.data.data[type]
  } catch (error) {
    console.log('Error al refrescar torneo')
  } finally {
    commit('updateLoading', false)
  }
}
